import React from "react";

const Footer = () => {
  return (
    <footer className="footer d-flex flex-column flex-md-row align-items-center justify-content-between">
      <p className="text-muted text-center text-md-left">
        Copyright © 2025 <b className="text-primary">Clediss</b>. All rights
        reserved
      </p>
    </footer>
  );
};

export default Footer;
